import { Modifier } from '../modifier';
import { invokeDie } from '../die.type';
import type { Player } from '../player.type';
import { actionHistory } from '../../../store';
import { DieFace } from '../face.type';
import {
  ModifierPriority,
  ModifierTags,
  StatusEffect,
  type ModifierParams,
} from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';

export class Infusion extends Modifier {
  static readonly baseTitle = 'Infusion';
  static readonly baseText =
    'At the start of the next action phase, invoke a die of the infused type.';
  static readonly baseIcon = 'infusion';
  static readonly baseTags = [ModifierTags.Boon];
  static readonly basePriority = ModifierPriority.Late;

  // Instance properties that can change
  title = Infusion.baseTitle;
  text = Infusion.baseText;
  icon = Infusion.baseIcon;
  tags: Array<ModifierTags> = [...Infusion.baseTags];
  priority = Infusion.basePriority;

  infusion: DieFace;

  constructor() {
    super();
    this.infusion = DieFace.Blank;
  }

  clone(newOwner: Player) {
    var clone = super.clone(newOwner);
    clone.infusion = this.infusion;

    return clone;
  }

  init(params: ModifierParams) {
    if (actionHistory) {
      actionHistory.push(`${this.owner.title} gained Infusion (${params.infusion}).`);
    }
    this.update(0, params);
  }

  update(stacks: number, params?: ModifierParams) {
    if (!params?.infusion) {
      throw new Error('Infusion modifier requires infusion type in params.');
    }

    if (this.infusion !== params.infusion) {
      actionHistory.push(
        `${this.owner.title} changed infusion from ${this.infusion} to ${params.infusion}.`,
      );
      this.infusion = params.infusion;
      this.title = `${this.type} (${this.infusion})`;
      this.stacks = 0;
    }
    this.bonusIcon = this.infusion;

    if (stacks) {
      this.stacks += stacks;
      actionHistory.push(`Added ${stacks} ${this.type} to ${this.owner.title}.`);
    }
  }

  actionPhaseStart() {
    invokeDie([this.infusion]);
    this.removeStacks(1);
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Infusion, Infusion);
